import { LexicalComposer } from '@lexical/react/LexicalComposer';

import Editor from './Editor';
import Toolbar from './Toolbar';
import defaultEditorConfig from './defaultEditorConfig';

export default { Editor, defaultEditorConfig, Toolbar, LexicalComposer };
